module.exports = __webpack_public_path__ + "static/img/organilog-04.fe081cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/organilog-04.png
// module id = 121
// module chunks = 0